import { createI18nProperty } from '@/i18n'
import _ from 'lodash'

export const TASK_STATUS = {
  ON: 'ON',
  OFF: 'OFF',
  DISABLED: 'DISABLED'
}

export const LAUNCHER_STATUS = {
  PENDING: 'PENDING',
  IN_QUEUE: 'IN_QUEUE',
  STARTING: 'STARTING',
  STARTED: 'STARTED',
  LOGIN: 'LOGIN',
  WAITING_LOGIN: 'WAITING_LOGIN',
  RUNNING: 'RUNNING',
  WAITING_VERIFY: 'WAITING_VERIFY',
  STOPPING: 'STOPPING',
  STOPPED: 'STOPPED',
  EXITED_ERROR: 'EXITED_ERROR',
  EXITED_NO_LOGIN: 'EXITED_NO_LOGIN',
  EXITED_NO_VERIFY: 'EXITED_NO_VERIFY'
}

export const LAUNCHER_DISPLAY_STATUS = {
  ACTIVE: 'ACTIVE',
  IN_QUEUE: 'IN_QUEUE',
  WAIT_VERIFY: 'WAIT_VERIFY',
  CLOSED: 'CLOSED',
  EXITED_ERROR: 'EXITED_ERROR',
  UNKNOWN: 'UNKNOWN'
}

export const ACTION_TYPE = {
  START: 'START',
  STOP: 'STOP',
  RESTART: 'RESTART',
  VERIFY: 'VERIFY'
}

export const ACTION_STATUS = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  CANCELED: 'CANCELED'
}

export const LAUNCHER_HAS_SCREENSHOT_STATUS = [
  LAUNCHER_STATUS.LOGIN,
  LAUNCHER_STATUS.WAITING_LOGIN,
  LAUNCHER_STATUS.RUNNING,
  LAUNCHER_STATUS.WAITING_VERIFY
]

export const LAUNCHER_STATUS_INFO_MAP = {
  [LAUNCHER_DISPLAY_STATUS.ACTIVE]: {
    displayStatus: LAUNCHER_DISPLAY_STATUS.ACTIVE,
    action: ACTION_TYPE.STOP,
    actionIconClass: 'iconfont iconClosed',
    statusList: [
      LAUNCHER_STATUS.PENDING,
      LAUNCHER_STATUS.STARTING,
      LAUNCHER_STATUS.STARTED,
      LAUNCHER_STATUS.RUNNING,
      LAUNCHER_STATUS.LOGIN
    ]
  },
  [LAUNCHER_DISPLAY_STATUS.IN_QUEUE]: {
    displayStatus: LAUNCHER_DISPLAY_STATUS.IN_QUEUE,
    action: ACTION_TYPE.STOP,
    actionIconClass: 'iconfont iconClosed',
    statusList: [
      LAUNCHER_STATUS.IN_QUEUE
    ]
  },
  [LAUNCHER_DISPLAY_STATUS.WAIT_VERIFY]: {
    displayStatus: LAUNCHER_DISPLAY_STATUS.WAIT_VERIFY,
    action: ACTION_TYPE.VERIFY,
    actionIconClass: 'iconfont iconVerify',
    statusList: [
      LAUNCHER_STATUS.WAITING_LOGIN,
      LAUNCHER_STATUS.WAITING_VERIFY
    ]
  },
  [LAUNCHER_DISPLAY_STATUS.CLOSED]: {
    displayStatus: LAUNCHER_DISPLAY_STATUS.CLOSED,
    action: ACTION_TYPE.START,
    actionIconClass: 'iconfont iconactive-01',
    statusList: [
      LAUNCHER_STATUS.STOPPING,
      LAUNCHER_STATUS.STOPPED
    ]
  },
  [LAUNCHER_DISPLAY_STATUS.EXITED_ERROR]: {
    displayStatus: LAUNCHER_DISPLAY_STATUS.EXITED_ERROR,
    action: ACTION_TYPE.RESTART,
    actionIconClass: 'iconfont iconrestart-03',
    statusList: [
      LAUNCHER_STATUS.EXITED_ERROR,
      LAUNCHER_STATUS.EXITED_NO_LOGIN,
      LAUNCHER_STATUS.EXITED_NO_VERIFY
    ]
  }
}

export const CHANNEL_ID = {
  JOB_51: 2,
  ZHI_LIAN: 3,
  LIE_PIN: 4,
  SHI_XI_SENG: 8,
  YI_MAI_TONG_DAO: 83
}

export const FEATURE_TYPE = {
  DOWNLOAD_RESUME: 'DOWNLOAD_RESUME',
  JOB_POSTING: 'JOB_POSTING',
  SHI_XI_SENG_SAVE_RESUME: 'SHI_XI_SENG_SAVE_RESUME',
  GET_JOB_DATA: 'GET_JOB_DATA'
}

export const dayRange = [0, 7, 15, 30]
export const channelOptionList = _.map(CHANNEL_ID, (value, key) => createI18nProperty({ value }, 'label', `admin.rpa.channelName.${key}`))
export const featureTypeOptionList = _.map(FEATURE_TYPE, (value, key) => createI18nProperty({ value }, 'label', `admin.rpa.featureType.${key}`))
